import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import GroupControls from "./GroupControls"
import GroupItemSearch from "./GroupItemSearch"
import IconBox from "../../../iconboxes/IconBox"

import classes from './Group.module.css'
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"

const GroupItem = ({data, dataId, groupData, label, folder, fieldsData, apiCase, smsMail}) => {
    let userPermissionDisabled = useUserTabEditPermissionDisabled(apiCase)
    const activeCase = useSelector(state => state.case.activeCase)
    const [activeCaseData, setActiveCaseData] = useState(data)

    useEffect(() => {
        if (activeCase) {
            if (folder != 'worker_comp') {
                let refresheditem = activeCase[folder].find(item => item.id == dataId)
                if (refresheditem) {
                    setActiveCaseData(refresheditem[label])
                }
            } else {
                let refresheditem = activeCase[folder]
                if (refresheditem) {
                    setActiveCaseData(refresheditem[label])
                }
            }
        }
    }, [activeCase, dataId, folder, label])

    return <div className={classes.row}>
        <div className={classes.select_container}>
            <GroupItemSearch label={label} activeCaseData={activeCaseData} data={groupData} fieldsData={fieldsData} folder={folder} apiCase={apiCase}/>            
        </div>
        {!userPermissionDisabled && <GroupControls folder={folder} groupData={groupData} groupDataID={groupData.id} individualData={activeCaseData} fieldsData={fieldsData} apiCase={apiCase}/>}
        <div className={classes.contact_information_group}>
            {activeCaseData.contact_information?.phone && <IconBox type={'phone'} link={activeCaseData.contact_information?.phone} ext={activeCaseData.contact_information?.phone_ext}>
                <i className="ti ti-phone"></i>
            </IconBox>}
            {activeCaseData.contact_information?.cell_phone && <IconBox type={'phone'} link={activeCaseData.contact_information?.cell_phone}>
                <i className="ti ti-device-mobile"></i>
            </IconBox>}
            {/* {activeCaseData.contact_information?.cell_phone && <IconBox type={'sms'} link={activeCaseData.contact_information?.cell_phone} smsMail={smsMail} fullInformation={data}>
                <i className="ti ti-device-mobile-message"></i>
            </IconBox>} */}

            {activeCaseData.contact_information?.fax && <IconBox type={'fax'} link={activeCaseData.contact_information?.fax} fullInformation={data}>
                <i className="ti ti-printer"></i>
            </IconBox>}

            {activeCaseData.contact_information?.email && <IconBox type={'mail'} link={activeCaseData.contact_information?.email} smsMail={smsMail} fullInformation={data}>
                <i className="ti ti-mail"></i>
            </IconBox>}
            
        </div>  
    </div>
}

export default GroupItem